export function getDateString(date): string {
    if (!date || !(date instanceof Date)) {
        return '';
    } else {
        return date.getFullYear() +
            '-' +
            (date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
            '-' +
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
    }
}



// WEBPACK FOOTER //
// ./src/utils/dateFormat.ts